import type {
  TGetCorretagensResponse,
  TParticipacaoImobiliariaCorretor,
} from '@/features/proposta/brasil/types/proposta.type'
import { resolverCorretagem } from '@/features/proposta/shared/domain/resolver-corretagem'

const imobiliariaCorretorVazio: TParticipacaoImobiliariaCorretor['imobiliariaCorretor'] = {
  descricao: '',
  idExterno: '',
  documento: '',
  tipoImobiliariaCorretor: 'Imobiliaria',
  nome: '',
}

export class CadastroImobiliariaCorretorEntity {
  constructor(
    private readonly listaCorretagensCadastradas: TGetCorretagensResponse,
    private readonly percentualCorretagemParametrizado: number | null,
    private readonly valorCorretagemParametrizado: number | null,
  ) {}

  obterCorretagemImobiliariaCorretorSelecionada(idExterno: string): TParticipacaoImobiliariaCorretor['corretagem'] {
    return this.resolver(this.listaCorretagensCadastradas.find((p) => p.idExterno === idExterno))
  }

  get novoCadastro(): TParticipacaoImobiliariaCorretor {
    return {
      imobiliariaCorretor: imobiliariaCorretorVazio,
      corretagem: this.resolver(undefined, { permitirValorApenasParametrizado: true }),
    } as TParticipacaoImobiliariaCorretor
  }

  private resolver(
    corretagem: TGetCorretagensResponse[number] | undefined,
    opcoes?: { permitirValorApenasParametrizado?: boolean },
  ): TParticipacaoImobiliariaCorretor['corretagem'] {
    const { tipo, valor } = resolverCorretagem(
      corretagem,
      this.percentualCorretagemParametrizado,
      this.valorCorretagemParametrizado,
      opcoes,
    )

    return tipo === 'percentual'
      ? { tipo: 'percentual', percentualCorretagemImobiliaria: valor }
      : { tipo: 'valor', valorCorretagemImobiliaria: valor }
  }
}
